import { Grid } from '@mui/material';
import { FC, SetStateAction, Dispatch } from 'react';
import {
  FiltersLayout,
  FiltersButtons,
  SearchField,
  PersonTypeDropdown,
  VendorDropdown
} from '../../../components';

interface IExternalFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setHasAppliedFilters: Dispatch<SetStateAction<boolean>>;
  hasAppliedFilters: boolean;
  setSearchValue?: (val: string) => void;
  setSearchedValue?: (val: string) => void;
  searchValue?: string;
  handleSearch?: (val: string) => void;
  setSelectedPersonType?: (val: string | number) => void;
  setSelectedPartnerId?: (val: string | number) => void;
  selectedPersonType?: string | number;
  selectedPartnerId?: string | number;
  searchPlaceholder?: string;
  isVendorAffiliate?: boolean;
}

export const ExternalFilters: FC<IExternalFilters> = ({
  isLoading,
  applyFilters,
  setHasAppliedFilters,
  hasAppliedFilters,
  handleSearch,
  searchValue,
  setSearchValue,
  setSearchedValue,
  setSelectedPersonType,
  selectedPersonType,
  searchPlaceholder,
  selectedPartnerId,
  setSelectedPartnerId,
  isVendorAffiliate
}) => {
  return (
    <FiltersLayout>
      {handleSearch && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <SearchField
            isDisabled={isLoading}
            placeholder={searchPlaceholder}
            handleSearch={handleSearch}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        </Grid>
      )}
      {setSelectedPartnerId && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <VendorDropdown
            isDisabled={isLoading}
            inputLabel="Company"
            value={selectedPartnerId}
            handleChange={value => {
              setSelectedPartnerId(value);
            }}
          />
        </Grid>
      )}
      {setSelectedPersonType && !isVendorAffiliate && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <PersonTypeDropdown
            isDisabled={isLoading}
            value={selectedPersonType}
            handleChange={value => {
              setSelectedPersonType(value);
            }}
          />
        </Grid>
      )}
      <Grid item xs={12} md={5} xl={3}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedPartnerId && setSelectedPartnerId('');
            setSelectedPersonType && setSelectedPersonType('');
            setSearchedValue && setSearchedValue('');
            setSearchValue && setSearchValue('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
